import _ from 'lodash';

import { jsonStringify } from 'utils/json';

export const formatBlob = value => {
  if (_.isNil(value)) {
    return null;
  }

  if (_.isString(value)) {
    return value;
  }

  return jsonStringify(value, null, 2);
};
